<template>
  <div :class="componentClassName">
    <a-page-heading>ユーザー管理 </a-page-heading>

    <m-section v-if="isUsersGroupExist" variant="fullpage">
      <m-action-card
        title="着信グループ編集"
        icon="phone-incoming-call-block"
        :header-border="true"
        :narrow-body="true"
      >
        <form ref="form" class="t-setting-user-groups-edit__form" @submit.prevent="handleFormSubmit">
          <div class="t-setting-user-groups-edit__fields">
            <m-form-input label="着信グループ名">
              <a-text-field id="groupIDInput" v-model="groupData.groupID" type="text" placeholder="着信グループ名" />
            </m-form-input>

            <m-user-selection-table v-model="groupData.user_selection" :user-list="userList" />

            <m-section>
              <a-caption-list>
                <li>一斉着信は最大10名まで指定できます</li>
                <li>自動応答システムを利用して分岐を設定すると、別の着信グループを設定できます</li>
              </a-caption-list>
            </m-section>

            <m-form-action-buttons>
              <a-button
                id="saveBtn"
                variant="block"
                color="primary"
                :disabled="!flagSaveButtonEnable"
                @click="handleFormSubmit"
                >保存</a-button
              >
              <a-button id="cancelBtn" variant="outlined" color="primary" @click="handleCancelClick"
                >キャンセル</a-button
              >
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingUserGroupEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import MUserSelectionTable from '@/components/molecules/user-selection-table';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT, PERMISSIONS_FRONTEND } from '@/libs/constants';

export default {
  name: 't-setting-user-groups-edit',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MUserSelectionTable,
    MFormInput,
    ATextField,
    ACaptionList,
    MFormActionButtons,
    AButton,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      groupData: {
        groupID: '',
        user_selection: [],
      },
      originGroupID: '',
      userList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      isUsersGroupExist: false,
      selectedCompanyID: '',
      flagSaveButtonEnable: true, //#1892
      authInfo: this.$store.state.user.authInfo,
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-user-groups-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    canEditUser() {
      if (this.companyID === POINT && this.authInfo === 'operator' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID === POINT && this.authInfo === 'soOperator') {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'operator') {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['userEdit'][this.authInfo];
      }
    },
  },
  async mounted() {
    this.selectedCompanyID = this.$route.query.companyID;
    if (!this.canEditUser) {
      this.$router.push({ path: '/permission-denied' });
    }
    const groupID = this.$route.query.groupID;
    if (groupID) {
      this.groupData.groupID = groupID;
      this.originGroupID = groupID;
      const userListObj = await this.handlerFetchUserData();
      if (userListObj) {
        this.userList = this.convertObjToArray(userListObj);
        this.handlerGetGroup(groupID);
      }
    }
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      const payload = cloneDeep(this.groupData);
      this.handleUpdateUserGroup(payload);
    },
    async handlerGetGroup(groupID) {
      await this.postRequest('/groupmgmt/getdata', { companyID: this.selectedCompanyID, groupID: groupID })
        .then(e => {
          if (e.status === 'success') {
            const clientNameList = e.data.clientNameList;
            const selectedList = [];
            this.userList.map(function (user, index) {
              if (clientNameList.includes(user.clientName)) {
                selectedList.push(index);
              }
            });
            this.groupData.user_selection = selectedList;
            this.isUsersGroupExist = true;
          } else {
            this.showErrorModal(messageContent.notExistItem(groupID));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('着信グループの取得'));
        });
    },
    async handlerFetchUserData() {
      return await this.postRequest('/idmgmt/getuserlist', { companyID: this.selectedCompanyID })
        .then(e => {
          return e.data;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
          return null;
        });
    },
    convertObjToArray(data) {
      const tempArray = [];
      Object.keys(data).map(function (key) {
        const obj = Object.assign({}, data[key]);
        obj.userID = key;
        obj.username = obj.username.replace('_', ' ');
        tempArray.push(obj);
      });
      return tempArray;
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/idmgmt', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push('/idmgmt');
      }
    },
    handleUpdateUserGroup(groupInfo) {
      // Validate 着信グループ名 maxlength
      const lengthCheck = this.incomingGroupNameLengthCheck(groupInfo.groupID);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      if (!groupInfo.groupID) {
        this.showErrorModal(messageContent.requireInput('着信グループ名'));
        return;
      } else if (this.hasSpecialCharacterInObject(groupInfo.groupID)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      } else if (groupInfo.user_selection.length === 0) {
        this.showErrorModal(messageContent.requireAtLeast1UserPerGroup);
        return;
      } else if (groupInfo.user_selection.length > 10) {
        this.showErrorModal(messageContent.upTo10MembersPerGroup);
        return;
      }
      // Only space check
      const onlySpaceChk = this.onlySpaceCheck(groupInfo.groupID, '着信グループ名');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }

      this.flagSaveButtonEnable = false; //#1892

      let path = '/groupmgmt/update';
      const clientNameList = groupInfo.user_selection.map(index => this.userList[index].clientName);
      let body = {
        groupID: groupInfo.groupID,
        data: { clientNameList: clientNameList },
        companyID: this.selectedCompanyID,
      };
      if (groupInfo.groupID !== this.originGroupID) {
        path = '/groupmgmt/changeGroup';
        body = {
          newGroupID: groupInfo.groupID,
          oldGroupID: this.originGroupID,
          data: { clientNameList: clientNameList },
          companyID: this.selectedCompanyID,
        };
      }
      this.postRequest(path, body)
        .then(e => {
          if (e.status === 'success') {
            this.flagSaveButtonEnable = true; //#1892
            if (groupInfo.groupID !== this.originGroupID) {
              // Update new originGroupID
              this.originGroupID = groupInfo.groupID;
              // Update new route due to groupID changed
              this.$router.push({ name: 'groupEdit', query: { groupID: groupInfo.groupID } });
            }
            this.showInfoModal(messageContent.incomingGroupSaved);
          } else if (e.status === 'groupExist') {
            this.showErrorModal(this.existItem(groupInfo.groupID));
          } else {
            this.showErrorModal(messageContent.requireTry('着信グループの編集'));
          }
          this.flagSaveButtonEnable = true; //#1892
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('着信グループの編集'));
          this.flagSaveButtonEnable = true; //#1892
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、ユーザ管理画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
  },
};
</script>
